import React from 'react';

export default function LandingPage() {
  const modules = [
    { id: 1, name: 'Shipment tracker', icon: '📊', color: 'from-blue-500 to-cyan-500' },
    { id: 2, name: 'Analytics', icon: '📈', color: 'from-purple-500 to-pink-500' },
    { id: 3, name: 'Management Summary', icon: '👥', color: 'from-green-500 to-emerald-500' },
    { id: 4, name: 'Quality Inspection', icon: '⚙️', color: 'from-orange-500 to-red-500' },
    { id: 5, name: 'Inspection', icon: '📄', color: 'from-indigo-500 to-purple-500' },
    { id: 6, name: 'Supported Documents', icon: '✉️', color: 'from-teal-500 to-blue-500' },
  ];

  return (
    <>
      <div className="h-full bg-gradient-to-br from-gray-900 via-gray-900 to-gray-900 flex items-center justify-center">
        {/* Background Decoration */}
        <div className="absolute overflow-hidden">
          {/* <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div> */}
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-pink-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse animation-delay-2000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse animation-delay-4000"></div>
        </div>

        <div className="relative z-10 max-w-6xl w-full">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 tracking-tight">
              Welcome to <span className="bg-gradient-to-r from-orange-400 via-orange-300 to-blue-400 bg-clip-text text-transparent">ReDoms</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 font-light">
              Please select the module from the sidebar to continue
            </p>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {modules.map((module) => (
              <div
                key={module.id}
                className="group relative overflow-hidden rounded-2xl bg-white bg-opacity-10 backdrop-blur-lg border border-white border-opacity-20 shadow-2xl transform transition-all duration-300 hover:scale-105 hover:shadow-purple-500/25 cursor-pointer"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${module.color} opacity-0 group-hover:opacity-20 transition-opacity duration-300`}></div>
                
                <div className="relative p-8 text-center">
                  <div className="text-6xl mb-6 transform transition-transform duration-300 group-hover:scale-110">
                    {module.icon}
                  </div>
                  <h3 className="text-2xl font-semibold text-white mb-2">
                    {module.name}
                  </h3>
                  <p className="text-gray-300 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Click to access
                  </p>
                  
                  <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transform translate-x-4 group-hover:translate-x-0 transition-all duration-300">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </div>
                </div>

                <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white to-transparent opacity-10 skew-x-12"></div>
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </>
  );
}